module.exports = __webpack_public_path__ + "static/solutions-fc3b05ddb164c60fd9efa373a46afa0c.svg";